<section class="shopee-lazada-video-online-wrapper">
  <div class="box-container">
    <div class="box">
      <div class="box__left">
        <!-- desktop heading -->
        <div
          class="box__heading color-gray box__heading--desktop"
          [innerHTML]="'SHOPEE_LAZADA.VIDEO_ONLINE.HEADING' | translate"
        >
        </div>

        <!-- tablet heading -->
        <div
          class="box__heading color-gray box__heading--tablet"
          [innerHTML]="'SHOPEE_LAZADA.VIDEO_ONLINE.HEADING_TABLET' | translate"
        >
        </div>

        <!-- mobile heading -->
        <div
          class="box__heading color-gray box__heading--mobile"
          [innerHTML]="'SHOPEE_LAZADA.VIDEO_ONLINE.HEADING_MOBILE' | translate"
        >
        </div>

        <div class="box__detail" [innerHTML]="'SHOPEE_LAZADA.VIDEO_ONLINE.DETAIL' | translate"></div>

        <div class="btn-wrapper">
          <a
            class="btn-try-free"
            href="https://form.flowaccount.com/flowaccountxlazada"
            rel="nofollow noopener"
            target="_blank"
            aria-label="link register try FlowAccount for free"
          >
            {{ 'SHOPEE_LAZADA.VIDEO_ONLINE.BTN_REGISTER_FOR_FREE' | translate }}
          </a>
        </div>
      </div>
      <div class="box__right">
        <div class="box__item" (click)="linkVideo('GX38rkyttWc')" data-toggle="modal" data-target="#functionVideo">
          <div class="box__item-cover">
            <div class="box__item-cover--bg"></div>
            <picture>
              <source
                srcset="
                  https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section4/Online_Shop_Seller_th_v2.webp
                "
                type="image/webp"
              />
              <source
                srcset="
                  https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section4/Online_Shop_Seller_th_v2.jpg
                "
                type="image/png"
              />
              <img
                src="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section4/FlowAccount_Online_Shop_Seller_th_v1.jpg"
                class="box__image"
                alt="วิดีโอ แค่ 3 นาทีก็ใช้ FlowAccount ช่วยขายของออนไลน์ได้"
                title="วิดีโอ แค่ 3 นาทีก็ใช้ FlowAccount ช่วยขายของออนไลน์ได้"
                loading="lazy"
              />
            </picture>

            <div class="box__item-cover--icon">
              <picture>
                <source
                  srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  type="image/webp"
                />
                <source
                  srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  type="image/jpeg"
                />
                <img
                  src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  class="icon-play"
                  alt="FlowAccount Testimonials"
                  title="FlowAccount Testimonials"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
